import React, { useEffect, useState, useRef } from "react";
import { Button, Form } from "react-bootstrap";
import SelectDropdown from "../../../ui/forms/SelectDropdown";
import { showToast } from "../../../utils/handleToast";
import { ArrowBack, ArrowForward } from "@material-ui/icons";
import { createSingleCase, getLitigationBranches, getLitigationClients } from "../../../API/litigationApis";

const assignmentTypeOptions = [
    { label: "Litigation", value: "litigation" },
    { label: "LSR", value: "lsr" },
];

const reliefSoughtOptions = [
    { label: "Civil Suit", value: "civil_suit" },
    { label: "NCLT", value: "nclt" },
    { label: "High Court", value: "high_court" },
    { label: "DRT", value: "drt" },
    { label: "Execution Petition (EP)", value: "execution_petition" },
    { label: "Original Application (OA)", value: "original_application" },
];

// mimi: Options for Filing Status
const filingStatusOptions = [
    { label: "Case Filed", value: "filed" },
    { label: "Case Not Filed", value: "not_filed" },
];

// Options for LAN Type
const lanTypeOptions = [
    { label: "Single", value: "single" },
    { label: "Multiple", value: "multiple" },
];

const lrnStatusOptions = [
    { label: "Active", value: "active" },
    { label: "Closed", value: "closed" },
    { label: "NPA", value: "npa" },
    { label: "Restructured", value: "restructured" },
];

const productTypeOptions = [
    { label: "Home Loan", value: "home_loan" },
    { label: "Personal Loan", value: "personal_loan" },
    { label: "Business Loan", value: "business_loan" },
    { label: "Credit Card", value: "credit_card" },
    { label: "Vehicle Loan", value: "vehicle_loan" },
];

const jurisdictionStateOptions = [
    { label: "Andhra Pradesh", value: "andhra_pradesh" },
    { label: "Arunachal Pradesh", value: "arunachal_pradesh" },
    { label: "Assam", value: "assam" },
    { label: "Bihar", value: "bihar" },
    { label: "Chhattisgarh", value: "chhattisgarh" },
    { label: "Goa", value: "goa" },
    { label: "Gujarat", value: "gujarat" },
    { label: "Haryana", value: "haryana" },
    { label: "Himachal Pradesh", value: "himachal_pradesh" },
    { label: "Jharkhand", value: "jharkhand" },
    { label: "Karnataka", value: "karnataka" },
    { label: "Kerala", value: "kerela" },
    { label: "Madhya Pradesh", value: "madhya_pradesh" },
    { label: "Maharashtra", value: "maharashtra" },
    { label: "Manipur", value: "manipur" },
    { label: "Meghalaya", value: "meghalaya" },
    { label: "Mizoram", value: "mizoram" },
    { label: "Nagaland", value: "nagaland" },
    { label: "Odisha", value: "odisha" },
    { label: "Punjab", value: "punjab" },
    { label: "Rajasthan", value: "rajasthan" },
    { label: "Sikkim", value: "sikkim" },
    { label: "Tamil Nadu", value: "tamil_nadu" },
    { label: "Telangana", value: "telangana" },
    { label: "Tripura", value: "tripura" },
    { label: "Uttar Pradesh", value: "uttar_pradesh" },
    { label: "Uttarakhand", value: "uttarakhand" },
    { label: "West Bengal", value: "west_bengal" },
    { label: "Delhi", value: "delhi" },
];

const CaseCategory = [
    { label: "Summary Suit", value: "summary_suit" },
    { label: "Commercial Suit", value: "comm_suit" },
    { label: "Execution Petition", value: "pre_ep" },
    { label: "Mediation Application", value: "mediation_application" },
    { label: "Interim Application", value: "interim_application" },
    { label: "Original Application", value: "original_application" },
    { label: "Loan Recall Notice", value: "loan_recall_notice" },
    { label: "Sec 95", value: "sec_95"}
];

const CaseCreation = ({ reloadPage = () => { } }) => {
    const [currentStep, setCurrentStep] = useState(1);
    const [loading, setLoading] = useState(false);
    const [clientOptions, setClientOptions] = useState([]);
    const [branchSearch, setBranchSearch] = useState('');
    const [filteredBranchOptions, setFilteredBranchOptions] = useState([]); 
    const [branchOptions, setBranchOptions] = useState([]); 
    const [loadingClients, setLoadingClients] = useState(false);
    const [loadingBranches, setLoadingBranches] = useState(false);

    const isMounted = useRef(true);
    const allBranches = useRef([]);

    const [formData, setFormData] = useState({
        assignmentType: "",
        clientName: "",
        branchName: "",
        customBranchName: "",
        assignedBy: "",
        assignmentDate: "",
        clientEmailId: "",
        clientContactNumber: "",
        reliefSought: [],
        loanAccountNumber: "",
        lrnStatus: "",
        lrnDate: "",
        borrowerName: "",
        borrowerAddress: "",
        borrowerAddress2: "",
        borrowerAddress3: "",
        borrowerAddress4: "",
        roi_amount: "",
        borrowerPhone: "",
        borrowerEmail: "",
        npaDate: "",
        totalLoanAmount: "",
        disbursalDate: "",
        productType: "",
        claimAmount: "",
        jurisdictionState: "",
        courtName: "",
        sendAutoRequisition: true,
        branch_address: "",
        product_name: "",
        charges_as_on_date: "",
        agreement_date: "",
        roi_percentage: "",
        incorpration_date: "",
        application_date: "",
        sanction_date: "",
        guarantor_name: "",
        guarantor_address: "",
        proprietor_name: "",
        proprietor_address: "",
        coborrower1_name: "",
        coborrower1_address: "",
        case_category: "",
        customClientName: "",

        // mimi: Fields for Filing Status and case details (Step 3)
        case_status: "", // Filing Status
        lan_type: "", // LAN Type
        case_no: "", // Case Number
        next_hearing_date: "", // Next Date
        stage_of_case: "", // Stage of Case
        comments: "", // Comments
    });

    useEffect(() => {
        setTimeout(() => {
            fetchClients();
        }, 500);
        return () => {
            isMounted.current = false;
        };
    }, []);

    // Debug: Log clientOptions whenever they change
    useEffect(() => {
        console.log("Client Options Updated:", clientOptions);
        console.log("Client Options Count:", clientOptions.length);
    }, [clientOptions]);

    useEffect(() => {
        // mimi: Client Email Auto-fill for Axis Bank
        if (formData.clientName === "axis_bank") {
            handleChange("clientEmailId", "Rajesh.poojary@axisbank.com");
        } else if (formData.clientName !== 'other') {
            const isBranchEmail = branchOptions.some(b => b.value === formData.branchName && b.branch_code === formData.clientEmailId);
            if (!isBranchEmail) {
                handleChange("clientEmailId", "");
            }
        }
    }, [formData.clientName]);

    const handleChange = (field, value) => {
        setFormData(prev => ({ ...prev, [field]: value }));
    };

    const fetchClients = async () => {
        setLoadingClients(true);
        try {
            console.log("Fetching clients...");
            const response = await getLitigationClients();
            
            
            // The response structure is: { status, data: { results: [...], count, page_number }, message }
            const results = response?.data?.results;
           
            
            if (Array.isArray(results) && results.length > 0) {
                console.log("Found", results.length, "clients");
                const options = results.map((client) => ({
                    label: client.full_name,
                    value: client.id, 
                }));
                console.log("Mapped options:", options);
                options.push({ label: "Add new", value: "other" });
                setClientOptions(options);
            } else {
                console.warn("No clients found or results is not an array");
                console.log("Fallback: setting only 'Add new' option");
                setClientOptions([{ label: "Add new", value: "other" }]);
            }
        } catch (error) {
            console.error("Error fetching clients:", error);
            showToast({ variant: "error", message: "Failed to fetch clients" });
            setClientOptions([{ label: "Add new", value: "other" }]);
        } finally {
            if (isMounted.current) {
                setLoadingClients(false);
            }
        }
    };

    /**
     * mimi: Fetches branches based on the selected client ID. Hits /api/branches/?client_id=...
     */
    const fetchBranches = async (clientId) => {
        if (!clientId || clientId === 'other') {
            allBranches.current = []; 
            setFilteredBranchOptions([]); 
            setBranchSearch(''); 
            setBranchOptions([]); 
            return;
        }

        setLoadingBranches(true);
        try {
            const response = await getLitigationBranches(clientId); 
            if (!isMounted.current) return;

            if (response?.data?.results) {
                const validBranches = response.data.results
                    .filter(branch => branch.branch_name && branch.branch_name.trim() !== "");

                // mimi: Storing auto-fill data directly in the options object.
                // NOTE: Using manager_email_id from the API response.
                const options = validBranches.map((branch) => ({
                    label: branch.branch_name,
                    value: branch.id, 
                    manager_name: branch.manager_name,
                    manager_email_id: branch.manager_email_id, 
                    branch_code: branch.branch_code,
                    manager_number: branch.manager_number,
                }));

                // Store full list in ref
                allBranches.current = options; 
                // Initial state: No search performed, so no branches are displayed in the dropdown until search begins
                setFilteredBranchOptions([]); 
                // Set initial branchOptions for other logic (like form submission label lookup)
                setBranchOptions([...options, { label: "Add new", value: "other" }]); 
            } else {
                 allBranches.current = [];
                 setFilteredBranchOptions([]);
                 setBranchOptions([{ label: "Add new", value: "other" }]);
            }
        } catch (error) {
            console.error("Error fetching branches:", error);
            showToast({ variant: "error", message: "Failed to fetch branches" });
            allBranches.current = [];
            setFilteredBranchOptions([]);
            setBranchOptions([{ label: "Add new", value: "other" }]);
        } finally {
            if (isMounted.current) {
                setLoadingBranches(false);
            }
        }
    };

    /**
     * mimi: Handler for Client Name change. Clears branches and triggers new branch fetch.
     */
    const handleClientChange = (clientId) => {
        handleChange("clientName", clientId);
        // mimi: Clear old branch data and dependent fields
        handleChange("branchName", ""); 
        handleChange("customBranchName", "");
        handleChange("customClientName", ""); 
        setBranchOptions([]);
        setBranchSearch('');
        setFilteredBranchOptions([]);
        
        // mimi: Clear auto-filled fields
        handleChange("assignedBy", "");
        handleChange("clientEmailId", "");
        handleChange("clientContactNumber", "");
        handleChange("assignmentDate", "");

        if (clientId && clientId !== 'other') {
            fetchBranches(clientId);
        } else {
            setLoadingBranches(false);
        }
    };

    /**
     * mimi: Handler for branch change that includes auto-fill logic.
     */
    const handleBranchSearchChange = (searchValue) => {
        
        setBranchSearch(searchValue);
        const lowerCaseSearch = searchValue.toLowerCase();

        // 1. Disable search if no client selected or 'other' client is selected
        if (!formData.clientName || formData.clientName === 'other') {
            setFilteredBranchOptions([]);
            return;
        }

        // 2. Clear the actual selection if the search text is no longer matching the selected branch label
        const selectedBranch = allBranches.current.find(b => b.value === formData.branchName);
        if (selectedBranch && !selectedBranch.label.toLowerCase().includes(lowerCaseSearch)) {
            handleChange('branchName', ''); // Clear the actual selection (value: id)
            // Also clear auto-filled fields when the branch is effectively deselected
            handleChange("assignedBy", "");
            handleChange("clientEmailId", "");
            handleChange("clientContactNumber", "");
        }

        // 3. Check for 3-character search activation
        if (searchValue.trim().length < 3) {
            // If less than 3 chars, only show "Add new" if the search matches 'Add new' related terms, otherwise show nothing.
            if (lowerCaseSearch.includes('add') || lowerCaseSearch.includes('new')) {
                setFilteredBranchOptions([{ label: "Add new", value: "other" }]);
            } else {
                 setFilteredBranchOptions([]);
            }
            return;
        }

        
        // 4. Search activated (3 or more chars)
        const filtered = allBranches.current.filter(branch =>
            branch.label.toLowerCase().includes(lowerCaseSearch)
        );
        
        // Always include the "Add new" option
        const filteredWithOptions = [...filtered, { label: "Add new", value: "other" }];
        setFilteredBranchOptions(filteredWithOptions);
    };

    /**
    * mimi: Handler for selecting a branch from the filtered list.
    */
    const handleBranchSelect = (selectedOption) => {
        
        // 1. Set the branch ID (or 'other') to the form data
        handleChange("branchName", selectedOption.value);

        
        // 2. Set the input field to the selected branch's label
        setBranchSearch(selectedOption.label);
        
        
        const today = new Date().toISOString().split('T')[0];

        if (selectedOption.value && selectedOption.value !== 'other') {
            // 3. Auto-fill logic for real branch
            handleChange("assignedBy", selectedOption.manager_name || ""); // Assigned By = manager_name
            handleChange("clientEmailId", selectedOption.manager_email_id || ""); 
            handleChange("clientContactNumber", selectedOption.manager_number || ""); 
            handleChange("assignmentDate", today); // Assignment Date = Current date

            // Clear custom input if a real branch is selected
            handleChange("customBranchName", "");

        } else if (selectedOption.value === 'other') {
            // 3. Logic for 'other' selected
            // Clear auto-filled fields (as 'other' branch doesn't have a manager/email) and set today's date
            handleChange("assignedBy", "");
            handleChange("clientEmailId", "");
            handleChange("clientContactNumber", "");
            handleChange("assignmentDate", today); 
        }

        // 4. Clear the filtered list after selection
        setFilteredBranchOptions([]); 
    };

    const handleMultiSelectChange = (field, value, checked) => {
        setFormData(prev => ({
            ...prev,
            [field]: checked
                ? [...prev[field], value]
                : prev[field].filter(item => item !== value)
        }));
    };

    const nextStep = () => {
        if (currentStep === 1 && formData.assignmentType === "lsr") {
            showToast({ variant: "info", message: "LSR module is under development" });
            return;
        }
        
        // mimi: Step 2 Validation (Client Details)
        if (currentStep === 2) {
            
            // mimi: Determine the FINAL Client Name value for validation
            const finalClientValue = formData.clientName === 'other'
                ? formData.customClientName
                : formData.clientName;

            // mimi: Client Name validation
            if (!finalClientValue || (typeof finalClientValue === 'string' && finalClientValue.trim().length === 0)) {
                showToast({ variant: "warning", message: "Client Name is required" });
                return;
            }

            // mimi: Determine the FINAL Branch Name value for validation
            const finalBranchValue = formData.branchName === 'other'
                ? formData.customBranchName
                : formData.branchName;

            // mimi: Branch Name validation
            if (!finalBranchValue || (typeof finalBranchValue === 'string' && finalBranchValue.trim().length === 0)) {
                showToast({ variant: "warning", message: "Branch Name is required" });
                return;
            }
            
            // Ensure Assigned By is present
            if (!formData.assignedBy || typeof formData.assignedBy !== 'string' || formData.assignedBy.trim().length === 0) {
                showToast({ variant: "warning", message: "Assigned By is required" });
                return;
            }

            // Ensure Assignment Date is present
            if (!formData.assignmentDate || typeof formData.assignmentDate !== 'string' || formData.assignmentDate.trim().length === 0) {
                showToast({ variant: "warning", message: "Assignment Date is required" });
                return;
            }

            // Ensure Client Email ID is present
            if (!formData.clientEmailId || typeof formData.clientEmailId !== 'string' || formData.clientEmailId.trim().length === 0) {
                showToast({ variant: "warning", message: "Client Email ID is required" });
                return;
            }

            // Ensure Client Contact Number is present
            if (!formData.clientContactNumber || typeof formData.clientContactNumber !== 'string' || formData.clientContactNumber.trim().length === 0) {
                showToast({ variant: "warning", message: "Client Contact Number is required" });
                return;
            }
            // mimi: Validation passed for Step 2!
        }

        // mimi: Step 3 Validation (Loan Details - Core mandatory fields only)
        if (currentStep === 3) {
            if (!formData.loanAccountNumber || !formData.loanAccountNumber.trim()) {
                showToast({ variant: "warning", message: "Loan Account Number is required" });
                return;
            }
            if (!formData.borrowerName || !formData.borrowerName.trim()) {
                showToast({ variant: "warning", message: "Borrower Name is required" });
                return;
            }
            // *** REMOVED MANDATORY VALIDATION FOR CLAIM AMOUNT ***
            // if (!formData.claimAmount || parseFloat(formData.claimAmount) <= 0) {
            //     showToast({ variant: "warning", message: "Claim Amount must be greater than zero" });
            //     return;
            // }
            if (!formData.reliefSought || formData.reliefSought.length === 0) {
                showToast({ variant: "warning", message: "Select at least one Relief Sought" });
                return;
            }
            // *** REMOVED MANDATORY VALIDATION FOR FILING STATUS (case_status) ***
            // if (!formData.case_status) {
            //     showToast({ variant: "warning", message: "Filing Status is required" });
            //     return;
            // }
            // *** REMOVED MANDATORY VALIDATION FOR LAN TYPE (lan_type) ***
            // if (!formData.lan_type) {
            //     showToast({ variant: "warning", message: "LAN Type is required" });
            //     return;
            // }
            
            // NOTE: Case Filed fields (case_no, next_hearing_date, stage_of_case) are now OPTIONAL.
        }
        
        // mimi: Step 4 Validation (Review & Generate) - No validation here as this is the final review step.

        setCurrentStep(currentStep + 1);
    };

    const prevStep = () => setCurrentStep(currentStep - 1);

    const createCase = async () => {
        // mimi: Final mandatory check (only core fields: Loan Account, Borrower, Relief Sought)
        if (!formData.loanAccountNumber.trim() || 
            !formData.borrowerName.trim() || 
            formData.reliefSought.length === 0) { 
                showToast({ variant: "error", message: "Please ensure Loan Account Number, Borrower Name, and Relief Sought are completed." });
                return;
        }

        if (formData.branchName === 'other' && !formData.customBranchName.trim()) {
            showToast({ variant: "warning", message: "Please enter the new branch name" });
            return;
        }

        if (!isMounted.current) return;

        setLoading(true);
        try {
            // mimi: Determine final values for submission
            const finalBranchName = formData.branchName === 'other'
                ? formData.customBranchName
                : branchOptions.find(b => b.value === formData.branchName)?.label || formData.branchName;
                
            const finalClientName = formData.clientName === 'other'
                ? formData.customClientName
                : clientOptions.find(c => c.value === formData.clientName)?.label || formData.clientName;
                
            // mimi: ONLY include fields defined by the steps (Step 2 and Step 3)
            const apiBody = {
                client: finalClientName,
                branch_name: finalBranchName,
                assignment_date: formData.assignmentDate,
                email_id: formData.clientEmailId,
                contact_no: formData.clientContactNumber,
                
                relief_sought: formData.reliefSought.join(','),
                lan_number: formData.loanAccountNumber,
                claim_amount: parseFloat(formData.claimAmount) || 0,
                customer_name: formData.borrowerName,
                
                case_status: formData.case_status, // This is now optional in the UI, but sent if filled
                lan_type: formData.lan_type, // lan_type to API body
                
                // Case filing details (case_no, next_hearing_date, stage_of_case, comments) are sent regardless of status, but are optional.
                case_no: formData.case_no,
                next_hearing_date: formData.next_hearing_date,
                stage_of_case: formData.stage_of_case,
                comments: formData.comments,

                // mimi: Included primary assignment type fields (kept for API compatibility)
                assignment_type: formData.assignmentType,
                assigned_by: formData.assignedBy,

                // mimi: All OTHER loan/address/date fields (like borrowerAddress, totalLoanAmount, npaDate etc.) 
                // are EXCLUDED as per the request to remove them from the flow and final API.
            };

            const response = await createSingleCase(apiBody);
            console.log(apiBody);

            if (!isMounted.current) return;

            if (response?.data) {
                showToast({ variant: "success", message: response.message || "Case created successfully!" });
                setTimeout(() => {
                    window.location.href = '/#/admin/litigation/batch';
                }, 1500);
                reloadPage();
            } else {
                throw new Error(response?.message || "Failed to create case");
            }
        } catch (error) {
            console.error("Error creating case:", error);
            if (isMounted.current) {
                showToast({ variant: "error", message: error.message || "Failed to create case" });
            }
        } finally {
            if (isMounted.current) {
                setLoading(false);
            }
        }
    };

    const renderStep1 = () => (
        <div className="card">
            <div className="card-body">
                <div className="row">
                    <div className="col-12">
                        <label className="form-label">Assignment Type</label>
                        <SelectDropdown
                            options={assignmentTypeOptions}
                            placeholder="Select assignment type"
                            value={formData.assignmentType}
                            onChange={(val) => handleChange("assignmentType", val)}
                        />
                        <small className="text-muted">Select the appropriate assignment category for your case</small>
                    </div>
                </div>
            </div>
            <div className="card-footer d-flex justify-content-end">
                <Button variant="primary" onClick={nextStep}>
                    Next <span style={{ marginLeft: '8px' }}><ArrowForward /></span>
                </Button>
            </div>
        </div>
    );

    const renderStep2 = () => (
        <div className="card">
            <div className="card-body">
                <div className="row mb-4">
                    <div className="col-md-4">
                        <label className="form-label">Client Name <span className="text-danger">*</span></label>
                        <SelectDropdown
                            options={clientOptions}
                            placeholder={loadingClients ? "Loading clients..." : "Select client"}
                            value={formData.clientName}
                            onChange={handleClientChange} 
                            disabled={loadingClients}
                        />
                        {formData.clientName === 'other' && (
                            <input
                                type="text"
                                className="form-control mt-2"
                                placeholder="Enter new client name"
                                value={formData.customClientName || ""}
                                onChange={(e) => handleChange("customClientName", e.target.value)}
                            />
                        )}

                    </div>
                    
                    <div className="col-md-4 position-relative">
                        <label className="form-label">Branch Name<span className="text-danger">*</span></label>
                        <input
                            type="text"
                            className="form-control"
                            placeholder={loadingBranches 
                                ? "Loading branches..." 
                                : (!formData.clientName || formData.clientName === 'other' 
                                    ? "Select client first" 
                                    : "Type Branch Name (min 3 chars)" )}
                            value={branchSearch}
                            onChange={(e) => handleBranchSearchChange(e.target.value)}
                            disabled={loadingBranches || !formData.clientName || formData.clientName === 'other'}
                            autoComplete="off"
                        />

                        {/* Display search results as an overlay */}
                        {/* The list shows when: 
                            1. The search length is 3+ OR 
                            2. The search resulted in only the 'Add new' option (e.g., user typed 'add') 
                        */}
                        {filteredBranchOptions.length > 0 && (branchSearch.length >= 3 || (filteredBranchOptions.length === 1 && filteredBranchOptions[0].value === 'other')) && (
                            <ul className="list-group position-absolute w-100 z-3 shadow" 
                                style={{ maxHeight: '200px', overflowY: 'auto', top: '100%', left: 0 }}>
                                
                                {filteredBranchOptions.map((branch) => (
                                    <li
                                        key={branch.value}
                                        className="list-group-item list-group-item-action"
                                        onClick={() => handleBranchSelect(branch)} 
                                        style={{ cursor: 'pointer' }}
                                    >
                                        {branch.label}
                                        {branch.value !== 'other' && (
                                            <small className="text-muted ms-2">({branch.manager_name})</small>
                                        )}
                                    </li>
                                ))}
                                
                                {/* Show a "No results" message if only "Add new" is visible and the user typed 3+ chars */}
                                {filteredBranchOptions.length === 1 && filteredBranchOptions[0].value === 'other' && branchSearch.length >= 3 && (
                                    <li className="list-group-item text-muted">No branches found for "{branchSearch}". Select "Add new".</li>
                                )}
                            </ul>
                        )}

                        {/* mimi: Show custom input field when "Other" is selected */}
                        {formData.branchName === 'other' && (
                            <input
                                type="text"
                                className="form-control mt-2"
                                placeholder="Enter new branch name"
                                value={formData.customBranchName}
                                onChange={(e) => handleChange("customBranchName", e.target.value)}
                            />
                        )}
                    </div>
                    <div className="col-md-4">
                        <label className="form-label">Assigned By <span className="text-danger">*</span></label>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Enter assigner's name"
                            value={formData.assignedBy}
                            onChange={(e) => handleChange("assignedBy", e.target.value)}
                        />
                    </div>
                </div>

                <div className="row mb-4">
                    <div className="col-md-4">
                        <label className="form-label">Assignment Date <span className="text-danger">*</span></label>
                        <input
                            type="date"
                            className="form-control"
                            value={formData.assignmentDate}
                            onChange={(e) => handleChange("assignmentDate", e.target.value)}
                        />
                    </div>
                    <div className="col-md-4">
                        <label className="form-label">Client Email ID <span className="text-danger">*</span></label>
                        <input
                            type="email"
                            className="form-control"
                            placeholder="Enter client's email"
                            value={formData.clientEmailId}
                            onChange={(e) => handleChange("clientEmailId", e.target.value)}
                        />
                    </div>
                    <div className="col-md-4">
                        <label className="form-label">Client Contact Number <span className="text-danger">*</span></label>
                        <input
                            type="tel"
                            className="form-control"
                            placeholder="Enter client's phone"
                            value={formData.clientContactNumber}
                            onChange={(e) => handleChange("clientContactNumber", e.target.value)}
                        />
                    </div>
                </div>

            </div>
            <div className="card-footer d-flex justify-content-between">
                <Button variant="secondary" onClick={prevStep}><ArrowBack /> Back</Button>
                <Button variant="primary" onClick={nextStep}>Next <span style={{ marginLeft: '8px' }}><ArrowForward /></span></Button>
            </div>
        </div>
    );

    /**
     * mimi: Step 3: Loan Details (4 core fields + Filing Status logic + LAN Type)
     */
    const renderStep3 = () => (
        <div className="card">
            <div className="card-body">
                <div className="row mb-4 ">
                    {/* 1) Loan Account No. */}
                    <div className="col-md-4 mb-4">
                        <label className="form-label">Loan Account Number <span className="text-danger">*</span></label>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Enter the loan account number"
                            value={formData.loanAccountNumber}
                            onChange={(e) => handleChange("loanAccountNumber", e.target.value)}
                        />
                    </div>

                    {/* 2) Borrower Name */}
                    <div className="col-md-4 mb-4">
                        <label className="form-label">Borrower Name <span className="text-danger">*</span></label>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Enter borrower's name"
                            value={formData.borrowerName}
                            onChange={(e) => handleChange("borrowerName", e.target.value)}
                        />
                    </div>

                    {/* 3) Claim Amount - Required validation removed */}
                    <div className="col-md-4 mb-4">
                        <label className="form-label">Claim Amount</label>
                        <div className="input-group">
                            <span className="input-group-text">₹</span>
                            <input
                                type="number"
                                className="form-control"
                                placeholder="e.g., 150000 (Optional)"
                                value={formData.claimAmount}
                                onChange={(e) => handleChange("claimAmount", e.target.value)}
                            />
                        </div>
                    </div>

                    {/* 4) Relief Sought */}
                    <div className="col-12 mb-4">
                        <label className="form-label">
                            Relief Sought <span className="text-danger">*</span>
                        </label>
                        <div className="row">
                            {reliefSoughtOptions.map((option) => (
                                <div key={option.value} className="col-md-4 col-sm-6 mb-2">
                                    <div className="form-check">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            id={`relief_${option.value}`}
                                            checked={formData.reliefSought.includes(option.value)}
                                            onChange={(e) => handleMultiSelectChange("reliefSought", option.value, e.target.checked)}
                                        />
                                        <label className="form-check-label" htmlFor={`relief_${option.value}`}>
                                            {option.label}
                                        </label>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* 5) Filing Status (case_status) - Now optional to proceed */}
                    <div className="col-md-4 mb-4">
                        <label className="form-label">Filing Status </label>
                        <SelectDropdown
                            options={filingStatusOptions}
                            placeholder="Select Filing Status (Optional)"
                            value={formData.case_status}
                            onChange={(val) => handleChange("case_status", val)}
                        />
                    </div>

                    {/* LAN Type (lan_type) - Now optional to proceed */}
                    <div className="col-md-4 mb-4">
                        <label className="form-label">LAN Type</label>
                        <SelectDropdown
                            options={lanTypeOptions}
                            placeholder="Select LAN Type (Optional)"
                            value={formData.lan_type}
                            onChange={(val) => handleChange("lan_type", val)}
                        />
                    </div>
                </div>

                {/* 5A - Case Filed fields */}
                {formData.case_status === 'filed' && (
                    <div className="row mb-4 border p-3 rounded">
                        <h6 className="mb-3">Case Filing Details (Optional)</h6>
                        
                        {/* Case Number (case_no) */}
                        <div className="col-md-4 mb-3">
                            <label className="form-label">Case Number</label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Enter case number"
                                value={formData.case_no}
                                onChange={(e) => handleChange("case_no", e.target.value)}
                            />
                        </div>

                        {/* Next Date (next_hearing_date) */}
                        <div className="col-md-4 mb-3">
                            <label className="form-label">Next Date</label>
                            <input
                                type="date"
                                className="form-control"
                                value={formData.next_hearing_date}
                                onChange={(e) => handleChange("next_hearing_date", e.target.value)}
                            />
                        </div>

                        {/* Stage of Case (stage_of_case) */}
                        <div className="col-md-4 mb-3">
                            <label className="form-label">Stage of Case</label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="e.g., Evidence, Arguments"
                                value={formData.stage_of_case}
                                onChange={(e) => handleChange("stage_of_case", e.target.value)}
                            />
                        </div>

                        {/* Comments */}
                        <div className="col-12">
                            <label className="form-label">Comments</label>
                            <textarea
                                className="form-control"
                                rows="1"
                                placeholder="Enter any relevant comments (optional)"
                                value={formData.comments}
                                onChange={(e) => handleChange("comments", e.target.value)}
                            />
                        </div>
                    </div>
                )}

                {/* 5B - Case Not Filed fields */}
                {formData.case_status === 'not_filed' && (
                    <div className="row mb-4 border p-3 rounded">
                        <h6 className="mb-0 text-success">Case Status: Case Not Filed. Continue to next step.</h6>
                    </div>
                )}
                
            </div>
            <div className="card-footer d-flex justify-content-between">
                <Button variant="secondary" onClick={prevStep}><ArrowBack /> Back</Button>
                <Button variant="primary" onClick={nextStep}>Next <span style={{ marginLeft: '8px' }}><ArrowForward /></span></Button>
            </div>
        </div>
    );

    /**
     * mimi: Step 4: Review & Generate
     */
    const renderStep4 = () => {
        const getLabel = (options, value) => options.find(o => o.value === value)?.label || value || 'Not specified';

        // mimi: Display logic for branch name in the summary
        let branchDisplay = 'Not specified';
        if (formData.branchName === 'other') {
            branchDisplay = formData.customBranchName || 'Not specified';
        } else if (formData.branchName) {
            branchDisplay = branchOptions.find(b => b.value === formData.branchName)?.label || formData.branchName;
        }

        return (
            <div className="card">
                <div className="card-body">
                    <div className="row mb-4">
                        <div className="col-12">
                            <h5 className="border-bottom pb-2">Case Summary</h5>

                            <h6 className="border-bottom pb-1 mt-3">Assignment & Client Details</h6>
                            <div className="row mb-3">
                                <div className="col-md-6">
                                    <strong>Assignment Type:</strong> {getLabel(assignmentTypeOptions, formData.assignmentType)}
                                </div>
                                <div className="col-md-6">
                                    <strong>Client:</strong> {clientOptions.find(c => c.value === formData.clientName)?.label || formData.customClientName || 'Not specified'}
                                </div>
                            </div>

                            <div className="row mb-3">
                                <div className="col-md-6">
                                    <strong>Branch:</strong> {branchDisplay}
                                </div>
                                <div className="col-md-6">
                                    <strong>Assigned By:</strong> {formData.assignedBy || 'Not specified'}
                                </div>
                            </div>

                            <div className="row mb-3">
                                <div className="col-md-6">
                                    <strong>Assignment Date:</strong> {formData.assignmentDate || 'Not specified'}
                                </div>
                                <div className="col-md-6">
                                    <strong>Client Email:</strong> {formData.clientEmailId || 'Not specified'}
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-md-6">
                                    <strong>Client Contact:</strong> {formData.clientContactNumber || 'Not specified'}
                                </div>
                            </div>

                            <h6 className="border-bottom pb-1 mt-4">Loan & Filing Status</h6>

                            <div className="row mb-3">
                                <div className="col-md-6">
                                    <strong>Loan Account:</strong> {formData.loanAccountNumber || 'Not specified'}
                                    {formData.loanAccountNumber && <span className="text-success ms-2"><i className="fas fa-check-circle"></i></span>}
                                </div>
                                <div className="col-md-6">
                                    <strong>Borrower:</strong> {formData.borrowerName || 'Not specified'}
                                </div>
                            </div>

                            <div className="row mb-3">
                                <div className="col-md-6">
                                    <strong>Claim Amount:</strong> {formData.claimAmount ? `₹ ${formData.claimAmount}` : 'Not specified'}
                                </div>
                                <div className="col-md-6">
                                    <strong>Relief Sought:</strong> {formData.reliefSought.length > 0
                                        ? formData.reliefSought.map(rs => reliefSoughtOptions.find(r => r.value === rs)?.label).join(', ')
                                        : 'Not specified'}
                                </div>
                            </div>

                            <div className="row mb-3">
                                <div className="col-md-6">
                                    <strong>Filing Status:</strong> {filingStatusOptions.find(f => f.value === formData.case_status)?.label || 'Not specified'}
                                </div>
                                <div className="col-md-6">
                                    <strong>LAN Type:</strong> {getLabel(lanTypeOptions, formData.lan_type)}
                                </div>
                            </div>

                            {/* mimi: Conditional Case Filing Details */}
                            {formData.case_status === 'filed' && (
                                <div className="row mb-3 border-top pt-3">
                                    <div className="col-md-6">
                                        <strong>Case Number:</strong> {formData.case_no || 'N/A'}
                                    </div>
                                    <div className="col-md-6">
                                        <strong>Next Date:</strong> {formData.next_hearing_date || 'N/A'}
                                    </div>
                                    <div className="col-md-6">
                                        <strong>Stage of Case:</strong> {formData.stage_of_case || 'N/A'}
                                    </div>
                                    <div className="col-md-6">
                                        <strong>Comments:</strong> {formData.comments || 'None'}
                                    </div>
                                </div>
                            )}

                            {/* mimi: All OTHER loan/address/date fields are removed from the summary as requested */}

                        </div>
                    </div>
                </div>
                <div className="card-footer d-flex justify-content-between">
                    <Button variant="secondary" onClick={prevStep}>
                        <ArrowBack /> Back
                    </Button>
                    <Button
                        variant={"primary"} 
                        onClick={createCase}
                        disabled={loading}
                    >
                        {loading ? (
                            <>
                                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                Creating Case...
                            </>
                        ) : (
                            <>
                                {"Create Case"}
                            </>
                        )}
                    </Button>
                </div>
            </div>
        );
    };

    const ProgressBar = () => {
        const getStepClass = (step) => {
            if (currentStep === step) return "active";
            if (currentStep > step) return "completed";
            return "";
        };

        // mimi: Adjusted progress bar for 4 steps: 1, 2, 3 (Loan Details), 4 (Review)
        return (
            <div className="progress-container mb-4">
                <div className="step-progress d-flex justify-content-around position-relative">
                    <div className="position-absolute w-100 top-50 translate-middle-y" style={{ height: '2px', backgroundColor: '#e9ecef', zIndex: 0 }} />
                    
                    <div className={`step text-center position-relative ${getStepClass(1)}`} style={{ flex: 1 }}>
                        <div className={`step-circle d-flex align-items-center justify-content-center mx-auto mb-1 rounded-circle ${getStepClass(1)}`} style={{ width: '45px', height: '45px', backgroundColor: '#e9ecef', color: '#6c757d', border: '2px solid #e9ecef', fontWeight: 600 }}>1</div>
                        <div className="step-text" style={{ fontSize: '0.9rem', fontWeight: 600 }}>Type of Assignment</div>
                    </div>

                    <div className={`step text-center position-relative ${getStepClass(2)}`} style={{ flex: 1 }}>
                        <div className={`step-circle d-flex align-items-center justify-content-center mx-auto mb-1 rounded-circle ${getStepClass(2)}`} style={{ width: '45px', height: '45px', backgroundColor: '#e9ecef', color: '#6c757d', border: '2px solid #e9ecef', fontWeight: 600 }}>2</div>
                        <div className="step-text" style={{ fontSize: '0.9rem', fontWeight: 600 }}>Client Details</div>
                    </div>

                    <div className={`step text-center position-relative ${getStepClass(3)}`} style={{ flex: 1 }}>
                        <div className={`step-circle d-flex align-items-center justify-content-center mx-auto mb-1 rounded-circle ${getStepClass(3)}`} style={{ width: '45px', height: '45px', backgroundColor: '#e9ecef', color: '#6c757d', border: '2px solid #e9ecef', fontWeight: 600 }}>3</div>
                        <div className="step-text" style={{ fontSize: '0.9rem', fontWeight: 600 }}>Loan Details</div>
                    </div>
                    <div className={`step text-center position-relative ${getStepClass(4)}`} style={{ flex: 1 }}>
                        <div className={`step-circle d-flex align-items-center justify-content-center mx-auto mb-1 rounded-circle ${getStepClass(4)}`} style={{ width: '45px', height: '45px', backgroundColor: '#e9ecef', color: '#6c757d', border: '2px solid #e9ecef', fontWeight: 600 }}>4</div>
                        <div className="step-text" style={{ fontSize: '0.9rem', fontWeight: 600 }}>Review & Generate</div>
                    </div>
                </div>
                <style>{`
                    .step.active .step-circle { background-color: #17a2b8 !important; color: white !important; border-color: #17a2b8 !important; }
                    .step.completed .step-circle { background-color: #28a745 !important; color: white !important; border-color: #28a745 !important; }
                    .step-text { color: #6c757d; }
                    .step.active .step-text, .step.completed .step-text { color: #212529; }
                    .step-progress { align-items: flex-start; }
                `}</style>
            </div>
        );
    };

    return (
        <div className="container-fluid py-4">
            <div className="row">
                <div className="col-12">
                    <ProgressBar />

                    {currentStep === 1 && renderStep1()}
                    {currentStep === 2 && renderStep2()}
                    {currentStep === 3 && renderStep3()}
                    {currentStep === 4 && renderStep4()}
                </div>
            </div>
        </div>
    );
};

export default CaseCreation;